module.exports = __webpack_public_path__ + "static/media/icon-camera.38752ab3.svg";